import { SortDirection } from '@core/types';

function getNestedValue<T>(obj: T, path: string): any {
  return path.split('.').reduce((acc, key) => acc && acc[key], obj);
}

export function sortData<T>(data: T[], column: string, direction: SortDirection): T[] {
  if (!column || !direction) return data;

  return [...data].sort((a, b) => {
    const aValue = getNestedValue(a, column);
    const bValue = getNestedValue(b, column);

    const res = String(aValue).localeCompare(String(bValue));
    return direction === 'asc' ? res : -res;
  });
}
